<div class="container-block-cod h-[70%] max-h-[70%] overflow-y-auto rounded-lg border border-gray-400 bg-gray-100 p-4">
  @if (this.onuDetails && this.onuDetails.full_status_json) {
  <p>Optical status</p>
  <div class="flex flex-wrap">
    <!-- Encabezados de la tabla -->
    <div class="w-1/4 p-2 font-bold">Wavelength</div>
    <div class="w-1/4 p-2 font-bold">OLT</div>
    <div class="w-1/4 p-2 font-bold">ONU</div>
    <div class="w-1/4 p-2 font-bold">Attenuation</div>

    <!-- Filas de la tabla -->
    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.optical_status.upstream_wavelength }}</div>
    <div class="w-1/4 p-2">Rx:{{ this.onuDetails.full_status_json.optical_status.olt_rx }}</div>
    <div class="w-1/4 p-2">Tx: {{ this.onuDetails.full_status_json.optical_status.onu_tx }}</div>
    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.optical_status['1310nm_attenuation'] }}</div>

    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.optical_status.downstream_wavelength }}</div>
    <div class="w-1/4 p-2">Tx: {{ this.onuDetails.full_status_json.optical_status.olt_tx }}</div>
    <div class="w-1/4 p-2">Rx: {{ this.onuDetails.full_status_json.optical_status.onu_rx }}</div>
    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.optical_status['1490nm_attenuation'] }}</div>

    <!-- Añade más filas según sea necesario -->
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">ONU CATV port</p>
  <div class="flex flex-wrap">
    <div class="w-1/4 p-2 font-bold">Admin status:</div>
    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.onu_catv_port.admin_status }}</div>
    <div class="w-1/4 p-2 font-bold">State:</div>
    <div class="w-1/4 p-2">{{ this.onuDetails.full_status_json.onu_catv_port.state }}</div>
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">ONU details</p>
  <div class="flex flex-wrap">
    <div class="w-1/2 p-2 font-bold">Vendor ID</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.vendor_id }}</div>
    <div class="w-1/2 p-2 font-bold">HW Version</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.hw_version }}</div>
    <div class="w-1/2 p-2 font-bold">Detected ONU Type</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.detected_onu_type }}</div>
    <div class="w-1/2 p-2 font-bold">Name</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.name }}</div>
    <div class="w-1/2 p-2 font-bold">Type</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.type }}</div>
    <div class="w-1/2 p-2 font-bold">State</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.state }}</div>
    <div class="w-1/2 p-2 font-bold">Current Channel</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.current_channel }}</div>
    <div class="w-1/2 p-2 font-bold">Admin State</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.admin_state }}</div>
    <div class="w-1/2 p-2 font-bold">Phase State</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.phase_state }}</div>
    <div class="w-1/2 p-2 font-bold">Serial Number</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.serial_number }}</div>
    <div class="w-1/2 p-2 font-bold">Description</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.description }}</div>
    <div class="w-1/2 p-2 font-bold">ONU Status</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.onu_status }}</div>
    <div class="w-1/2 p-2 font-bold">ONU Distance</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.onu_distance }}</div>
    <div class="w-1/2 p-2 font-bold">Online Duration</div>
    <div class="w-1/2 p-2">{{ this.onuDetails.full_status_json.onu_details.online_duration }}</div>
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">History</p>

  <div class="flex flex-wrap">
    <!-- Encabezados de la tabla -->
    <div class="w-1/3 p-2 font-bold">Authpass Time</div>
    <div class="w-1/3 p-2 font-bold">OfflineTime</div>
    <div class="w-1/3 p-2 font-bold">Cause</div>

    <!-- Filas de la tabla -->
    @for (item of this.onuDetails.full_status_json.history | keyvalue; track $index) {
    <div class="w-1/3 p-2">{{ item.value.auth_at }}</div>
    <div class="w-1/3 p-2">{{ item.value.offline_at }}</div>
    <div class="w-1/3 p-2">{{ item.value.cause }}</div>
    }
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">ONU WAN Interfaces</p>
  <div class="flex flex-wrap">
    <div class="w-1/6 p-2 font-bold">MAC address</div>
    <div class="w-1/6 p-2 font-bold">IPv4 address</div>
    <div class="w-1/6 p-2 font-bold">Subnet mask</div>
    <div class="w-1/6 p-2 font-bold">Default gateway</div>
    <div class="w-1/6 p-2 font-bold">DNS server 1</div>
    <div class="w-1/6 p-2 font-bold">DNS server 2</div>

    @for (item of this.onuDetails.full_status_json.onu_wan_interfaces | keyvalue; track $index) {
    <div class="w-1/6 p-2">{{ item.value.mac_address }}</div>
    <div class="w-1/6 p-2">{{ item.value.ipv4_address }}</div>
    <div class="w-1/6 p-2">{{ item.value.subnet_mask }}</div>
    <div class="w-1/6 p-2">{{ item.value.default_gateway }}</div>
    <div class="w-1/6 p-2">{{ item.value.dns_server_1 }}</div>
    <div class="w-1/6 p-2">{{ item.value.dns_server_2 }}</div>
    }
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">ONU LAN Interfaces</p>
  <div class="flex flex-wrap">
    <div class="w-1/4 p-2 font-bold">Port</div>
    <div class="w-1/4 p-2 font-bold">Speed</div>
    <div class="w-1/4 p-2 font-bold">Admin</div>
    <div class="w-1/4 p-2 font-bold">Max-frame</div>

    @for (item of this.onuDetails.full_status_json.onu_lan_interfaces_status | keyvalue; track $index) {
    <div class="w-1/4 p-2">{{ item.key }}</div>
    <div class="w-1/4 p-2">{{ item.value.speed }}</div>
    <div class="w-1/4 p-2">{{ item.value.admin_state }}</div>
    <div class="w-1/4 p-2">{{ item.value.max_frame_size }}</div>
    }
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">Realtime VLAN info</p>
  <div class="flex flex-wrap">
    <div class="w-1/5 p-2 font-bold">Interface</div>
    <div class="w-1/5 p-2 font-bold">Mode</div>
    <div class="w-1/5 p-2 font-bold">VLAN-ID</div>
    <div class="w-1/5 p-2 font-bold">Def-Prio</div>
    <div class="w-1/5 p-2 font-bold">Vlan-list</div>

    @for (item of this.onuDetails.full_status_json.realtime_vlan_info | keyvalue; track $index) {
    <div class="w-1/5 p-2">{{ item.key }}</div>
    <div class="w-1/5 p-2">{{ item.value.mode }}</div>
    <div class="w-1/5 p-2">{{ item.value.vlan_id }}</div>
    <div class="w-1/5 p-2">{{ item.value.def_prio }}</div>
    <div class="w-1/5 p-2">{{ item.value.vlan_list }}</div>
    }
  </div>

  <p class="mt-6 border-t-2 border-gray-500 pt-6">MACs on OLT from this ONU</p>
  <div class="flex flex-wrap">
    <div class="w-1/5 p-2 font-bold">Mac address</div>
    <div class="w-1/5 p-2 font-bold">Vlan</div>
    <div class="w-1/5 p-2 font-bold">Type</div>
    <div class="w-1/5 p-2 font-bold">Port</div>
    <div class="w-1/5 p-2 font-bold">Vc</div>

    @for (item of this.onuDetails.full_status_json.macs_on_olt_from_this_onu | keyvalue; track $index) {
    <div class="w-1/5 p-2">{{ item.value.mac_address }}</div>
    <div class="w-1/5 p-2">{{ item.value.vlan }}</div>
    <div class="w-1/5 p-2">{{ item.value.type }}</div>
    <div class="w-1/5 p-2">{{ item.value.port }}</div>
    <div class="w-1/5 p-2">{{ item.value.vc }}</div>
    }
  </div>
  }
</div>
